import * as React from "react";

import { WithTranslation, withTranslation } from "react-i18next";
import { shopConfig } from "~/helpers/shopConfig";
import { StyledCallout as Callout } from "~/layouts/StyledCallout";
import styled from "~/styled";

const Typography = styled.p`
  font-size: 14px;
  margin-top: 8px;

  @media (max-width: 375px) {
    font-size: 12px;
  }

  @media (max-width: 320px) {
    font-size: 10px;
  }
`;

class LegalAddress extends React.Component<WithTranslation> {
  public render() {
    const { t } = this.props;
    const { organization } = shopConfig;

    if (organization === "emerchant") {
      return (
        <Callout title={t("footer.address.title")} intent="primary" icon={null}>
          <Typography>
            17 WALMER DRIVE SERANGOON GARDEN ESTATE 555042 SINGAPORE
          </Typography>
        </Callout>
      );
    }

    return (
      <Callout title={t("footer.address.title")} intent="none" icon={null}>
        <Typography>
          Rm 816, Level 8, Landmark North, 39 Lung Sum Avenue, Sheung Shui NT,
          Hong Kong SAR
        </Typography>
      </Callout>
    );
  }
}

export default withTranslation("general")(LegalAddress);



// WEBPACK FOOTER //
// ./src/components/Legal/LegalAddress.tsx